import * as React from "react";
const CROSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={69}
    height={68}
    fill="none"
    {...props}
  >
    <rect
      width={60}
      height={60}
      x={4.332}
      y={4}
      fill="#040919"
      fillOpacity={0.02}
      rx={30}
    />
    <rect
      width={60}
      height={60}
      x={4.332}
      y={4}
      stroke="#040919"
      strokeOpacity={0.03}
      strokeWidth={8}
      rx={30}
    />
    <path
      fill="#040919"
      d="m45.641 29.293-7-7a1 1 0 0 0-.707-.293h-15a1 1 0 0 0-1 1v15a1 1 0 0 0 .287.701l7 7a1 1 0 0 0 .713.299h15a1 1 0 0 0 1-1V30a1 1 0 0 0-.293-.707Zm-6.707-3.88L42.52 29h-3.586v-3.586Zm-10 17.173L25.347 39h3.587v3.586Zm0-5.586h-5V25.414l5 5V37Zm-3.587-13h11.587v5h-6.587l-5-5Zm11.587 7v6h-6v-6h6Zm-6 13v-5h6.586l5 5H30.934Zm13-1.414-5-5V31h5v11.586Z"
    />
  </svg>
);
export default CROSVG;
